<template>
  <div class="mt-3">
      <div v-if="provider === null">
        <b-button class="btn-block authSubmit bankId" v-b-modal.selectNationality>Sign In with Electronic ID</b-button>
      </div>
      <div v-else-if="provider === 'seBankID'">
        <a :href="'/eid/login/'+provider" class="btn btn-primary authSubmit btn-block w-100 text-dark bankId">
          <img height="32" class="mr-3" src="img/bankid-icon-color.png">
          <span>Login with BankID</span>
        </a>
      </div>
      <div v-else-if="provider === 'dkMitID'">
        <a :href="'/eid/login/'+provider" class="btn btn-primary authSubmit btn-block w-100 text-dark bankId">
          <img height="14" class="mr-3" src="img/dkmitid-icon-color.png">
          <span>Login with MitID</span>
        </a>
      </div>
      <div v-else-if="provider === 'dkNemID'">
          <a :href="'/eid/login/'+provider" class="btn btn-primary authSubmit btn-block w-100 text-dark bankId">
              <img height="12" class="mr-3" src="img/dknemid-icon-black.png">
              <span>Login with NemId</span>
          </a>
      </div>
      <div v-else-if="provider === 'noBankID'">
          <a :href="'/eid/login/'+provider" class="btn btn-primary authSubmit btn-block w-100" style="background: #4a78b1;">
              <img height="12" class="mr-3" src="img/bankid_main_logo_white.svg">
              <span>Login with BankID</span>
          </a>
      </div>
      <div v-else-if="provider === 'fiTupas'">
          <a :href="'/eid/login/'+provider" class="btn btn-primary authSubmit btn-block w-100 text-dark bankId">
              <img height="70" class="mr-3" src="img/ftn-logo.svg">
              <span>Login with FTN</span>
          </a>
      </div>
      <div v-else class="text-center">
        <span class="text-muted">-</span>
      </div>
      <div v-if="provider !== null && multiple" class="mt-3">
        <a href="#" @click="$bvModal.show('selectNationality')" class="text-muted readable-text">
          <i class="flag-icon mr-2" :class="'flag-icon-'+selected.toLowerCase()"></i>{{country}}
        </a>
      </div>

    <b-modal id="selectNationality" size="sm" centered title="BootstrapVue" hide-footer>
      <template #modal-title>
        Select Nationality
      </template>
      <div class="px-3" style="margin-top: -.75rem;">
        <div class="charge-select-menu mb-4">
          <a v-for="(country, code) in countries"
             class="charge-select-item d-flex justify-content-between align-items-center" href="#"
             @click="select(code)">
            <div>
              <i class="flag-icon mr-2" :class="'flag-icon-'+code.toLowerCase()"></i>
              <span style="font-size: 0.88rem;">{{ country.name || code }}</span></div>
            <div>
                <img v-if="country.provider === 'seBankID'" height="24" src="img/bankid-icon-color.png"
                   style="filter: brightness(4)">
                <img v-if="country.provider === 'dkMitID'" height="10" src="img/dkmitid-icon-white.png"
                   style="">
                <img v-if="country.provider === 'dkNemID'" height="12" src="img/dknemid-icon-white.png"
                     style="margin-top: -4px;">
                <img v-if="country.provider === 'noBankID'" height="12" src="img/bankid_main_logo_white.svg"
                     style="margin-top: -4px;">
                <img v-if="country.provider === 'fiTupas'" height="40" src="img/ftn-logo.svg"
                     style="margin-top: -10px;margin-bottom:-10px;filter: brightness(3);">
            </div>
          </a>
        </div>
        <b-button class="btn btn btn-dark authSubmit btn-block mb-3 btn-secondary" style="min-width: 5rem;"
                  @click="$bvModal.hide('selectNationality')">Close
        </b-button>
      </div>
    </b-modal>
  </div>

</template>

<script>
import Cookies from 'js-cookie'

const PREFERENCE_COOKIE = 'chargeLoginNationalityPreference';

export default {
  name: 'ScriveLogin',
  props: {
    default: {
      type: String,
      required: false,
    },
    config: {
      type: String,
      required: true,
    },
  },
  data() {
    const countries = JSON.parse(this.config) || [];
    const codes = Object.keys(countries);

    // Look for property default or cookie default.
    let defaultNationality = Cookies.get(PREFERENCE_COOKIE) || this.default;
    // Check if the default code exists, if not return null (or if we only have one country we return it)
    let selected = codes.includes(defaultNationality) ? defaultNationality : (codes.length === 1 ? codes[0] : null);
    // If select is still null we can assume their nationality through the browser language settings.
    if (selected === null) {
      let navLang = navigator.language;

      // attempt to convert language (ISO 639) to country (ISO 3166), should use location based check in the future.
      switch (navLang) {
          case 'nob':
          case 'nb':
              navLang = 'no';
              break;
          case 'sv':
          case 'swe':
              navLang = 'se';
              break;
          case 'da':
          case 'dan':
              navLang = 'dk';
              break;
          case 'fin':
              navLang = 'fi';
              break;
      }

      codes.forEach((code) => {
        console.log(`testing ${navLang} to ${code}`)
        if (new RegExp(`${code}$`, 'i').test(navLang)) {
          selected = code;
        }
      });
    }

    return {
      countries: countries,
      selected: selected,
    };
  },
  methods: {
    select(code) {
      Cookies.set(PREFERENCE_COOKIE, code, { expires: 365 });
      this.selected = code;
      this.$bvModal.hide('selectNationality');
    },
  },
  computed: {
    multiple() {
      return Object.keys(this.countries).length > 1;
    },
    provider() {
      if (this.selected === null) {
        return null;
      }
      return this.countries[this.selected].provider || null;
    },
    country() {
      if (this.selected === null) {
        return null;
      }
      return this.countries[this.selected].name || null;
    }
  },
};
</script>

<style scoped>
    .authSubmit {
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
